export const PUBNUB_GLOBAL_NOTIFICATION_RECEIVED = 'la/domain/globalNotification/PUBNUB_GLOBAL_NOTIFICATION_RECEIVED';
